__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "loja-digital-attendance-mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@grupoboticario/flora-react-icons", "9.0.8", () => (Promise.all([__webpack_require__.e(610), __webpack_require__.e(2950), __webpack_require__.e(1765)]).then(() => (() => (__webpack_require__(60610))))));
			register("@grupoboticario/flora-react-toast", "3.2.13", () => (Promise.all([__webpack_require__.e(7224), __webpack_require__.e(7088), __webpack_require__.e(2950), __webpack_require__.e(2181), __webpack_require__.e(1765), __webpack_require__.e(2218)]).then(() => (() => (__webpack_require__(67088))))));
			register("@grupoboticario/flora-react", "0.13.68", () => (Promise.all([__webpack_require__.e(9539), __webpack_require__.e(7224), __webpack_require__.e(6254), __webpack_require__.e(1591), __webpack_require__.e(2950), __webpack_require__.e(2181), __webpack_require__.e(1765), __webpack_require__.e(2364), __webpack_require__.e(3969), __webpack_require__.e(2218)]).then(() => (() => (__webpack_require__(41591))))));
			register("@grupoboticario/flora", "0.20.0", () => (Promise.all([__webpack_require__.e(8233), __webpack_require__.e(2950)]).then(() => (() => (__webpack_require__(8233))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(9539), __webpack_require__.e(3935), __webpack_require__.e(2950)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-redux", "^7.2.4", () => (Promise.all([__webpack_require__.e(9539), __webpack_require__.e(2100), __webpack_require__.e(2950), __webpack_require__.e(2181)]).then(() => (() => (__webpack_require__(82100))))));
			register("react-router-dom", "6.5.0", () => (Promise.all([__webpack_require__.e(9539), __webpack_require__.e(9818), __webpack_require__.e(2950)]).then(() => (() => (__webpack_require__(49818))))));
			register("react", "17.0.2", () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(67294))))));
			register("styled-components", "4.1.3", () => (Promise.all([__webpack_require__.e(9539), __webpack_require__.e(6493), __webpack_require__.e(2950), __webpack_require__.e(2181)]).then(() => (() => (__webpack_require__(16493))))));
			initExternal(38165);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};